import {
  FormValues,
  SYSTEM_CODES,
  SYSTEM_CODE_NUMBERS,
  validateNewPassword,
} from '../../duck';
import { HStack, Icon, Text, VStack } from '@chakra-ui/react';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import {
  IoCheckmarkCircleOutline,
  IoCloseCircleOutline,
} from 'react-icons/io5';

const PasswordRequirements: React.FC = () => {
  const { watch } = useFormContext<FormValues>();
  const newPassword = watch('newPassword');

  const validationErrorCodes = newPassword
    ? validateNewPassword(newPassword)
    : [];

  return (
    <VStack
      spacing={6}
      alignItems="flex-start"
      p={4}
      background="blue.50"
      flex="50%"
    >
      <Text fontWeight="bold">New Password Requirements</Text>
      <VStack alignItems="flex-start" spacing={0} w="100%">
        {Object.keys(SYSTEM_CODES).map((id) => {
          const isInvalid = validationErrorCodes.includes(
            id as unknown as SYSTEM_CODE_NUMBERS
          );
          return (
            <HStack
              w="100%"
              key={id}
              p={1}
              backgroundColor={
                newPassword ? (isInvalid ? 'red.50' : 'green.50') : undefined
              }
              color={
                newPassword ? (isInvalid ? 'red.700' : 'green.700') : undefined
              }
            >
              <Icon
                as={isInvalid ? IoCloseCircleOutline : IoCheckmarkCircleOutline}
              />
              <Text>{SYSTEM_CODES[id as unknown as SYSTEM_CODE_NUMBERS]}</Text>
            </HStack>
          );
        })}
      </VStack>
      <Text>
        Check that your new password does not contain your first name or last
        name and does not match your last five passwords.
      </Text>
    </VStack>
  );
};

export default PasswordRequirements;
